import { bunja } from 'bunja';
import { atom } from 'jotai';
import { ComponentProps, ReactElement, ReactNode } from 'react';

import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import { EventEmitter } from '@flipster/utils/event-emitter';
import { generateID } from '@flipster/utils/identity';

import { TextButton } from '../text-button';

export interface SnackbarOptions {
  id: string;
  status: 'success' | 'warning' | 'error';
  message: ReactNode;
  button?: ReactElement<ComponentProps<typeof TextButton>>; // TEMP react 폴더로 옮기기전 순환참조 때문에 ReactNode 로 대체
}

const snackbarEmitter = new EventEmitter<{ show: SnackbarOptions }>();

type AddOptions = Pick<SnackbarOptions, 'message' | 'button'>;

const idPrefix = 'snackbar-';

export const snackbar = {
  success(options: AddOptions) {
    const id = generateID(idPrefix);
    snackbarEmitter.emit('show', { id, status: 'success', ...options });
    return id;
  },
  warning(options: AddOptions) {
    const id = generateID(idPrefix);
    snackbarEmitter.emit('show', { id, status: 'warning', ...options });
    return id;
  },
  error(options: AddOptions) {
    const id = generateID(idPrefix);
    snackbarEmitter.emit('show', { id, status: 'error', ...options });
    return id;
  },
};

// show 2s
// max count 3
const visibleSecs = 2 * 1000;
const maxCount = 3;

export const snackbarBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const snackbarsAtom = atom<SnackbarOptions[]>([]);
  snackbarsAtom.debugLabel = 'snackbarsAtom';

  const timers: Record<string, NodeJS.Timeout> = {};

  function remove(id: string) {
    store.set(snackbarsAtom, (snackbars) => snackbars.filter((s) => s.id !== id));
  }

  const listener = (options: SnackbarOptions) => {
    const { id } = options;
    store.set(snackbarsAtom, [...store.get(snackbarsAtom), options].slice(maxCount * -1));
    timers[id] = setTimeout(() => remove(id), visibleSecs);
  };

  bunja.effect(() => {
    snackbarEmitter.on('show', listener);
    return () => {
      snackbarEmitter.off('show', listener);
      Object.values(timers).forEach((t) => clearTimeout(t));
    };
  });

  return {
    snackbarsAtom,
    remove,
  };
});
snackbarBunja.debugLabel = 'snackbarBunja';
